import type { CfAssetDrag } from '@repo/studio-components-asset-drag/asset'
import { create } from 'zustand'

interface ExternalAssetDropState {
  queue: CfAssetDrag[]
  enqueue: (asset: CfAssetDrag) => void
  drain: () => CfAssetDrag[]
}

export const useExternalAssetDropStore = create<ExternalAssetDropState>((set, get) => ({
  queue: [],
  enqueue: asset => set(state => ({ queue: [...state.queue, asset] })),
  drain: () => {
    const queue = get().queue
    set({ queue: [] })
    return queue
  },
}))
